<template>
    <div class="detail">
        <div class="left">
            <div class="container">
                <el-form :model="ruleForm" ref="ruleForm" label-width="120px" class="demo-ruleForm">
                    <el-card class="card-item box-card">
                        <div class="card-title clearfix" slot="header">
                        <span>基本信息</span>
                        </div>
                        <div class="card-content">
                            <el-row>
                                <el-col :span="22">
                                    <el-form-item label="项目名称：">
                                        {{ruleForm.businessName}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                    <el-form-item label="项目编码：">
                                        {{ruleForm.businessCode}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                    <el-form-item label="预约人：">
                                        {{ruleForm.applicant}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                    <el-form-item label="业务类型：">
                                        <el-radio-group v-model="ruleForm.businessType">
                                        <el-radio v-for="item in businessTypeList" disabled :label="item.id" :key="item.id">{{ item.text }}</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                    <el-form-item label="保密性：">
                                        <el-radio-group v-model="ruleForm.secrecyStatus">
                                        <el-radio v-for="item in secrecyStatusList" disabled :label="item.id" :key="item.id">{{ item.text }}</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                <el-form-item label="业务细分类：">
                                    <el-radio-group v-model="ruleForm.businessClassfy">
                                    <el-radio v-for="item in fieldBusClass" :label="item.id" disabled :key="item.id">{{ item.text }}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </el-card>
                    <el-card class="card-item box-card" v-for="(applyItem,idx) in ruleForm.details" :key="idx">
                        <div class="card-title clearfix"  slot="header">
                        <span>{{ convertApplyType(applyItem.applyType) }}场地预约</span>
                        </div>
                        <div class="card-content">
                            <el-row>
                                <el-col :span="11">
                                    <el-form-item label="场地：">
                                        {{applyItem.fieldName}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="22">
                                    <el-form-item label="预约时段：">
                                        <el-radio-group v-model="applyItem.applyTimeInterval+''">
                                        <el-radio v-for="item in applyTimeIntervalList" disabled :label="item.id" :key="item.id">{{ item.text }}
                                        </el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                    <el-form-item label="预计开始时间：">
                                        {{applyItem.applyTime}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                    <el-form-item label="预计结束时间：">
                                        {{applyItem.useEndTime}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                    <el-form-item label="预约机位数：">
                                        {{applyItem.machines}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                    <el-form-item label="容纳人数：">
                                        {{applyItem.capacity}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="22">
                                    <el-form-item label="备注：">
                                        {{applyItem.remark}}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </el-card>
                </el-form>
            </div>
            <el-card class="box-card" style="margin-top: 15px">
                <div slot="header" class="clearfix">
                    <span>流程信息</span>
                </div>
                <flow-chart ref="flowChart"
                            :dialogVisible.sync="dialogVisible"
                            :auditForm.sync="auditForm"
                            @auditProcessSubmit="auditProcessSubmit"
                            @getFlowInfoSuccess="getFlowInfoSuccess">
                </flow-chart>
            </el-card>
        </div>
        <div class="btns">
            <ul>
                <li><a href="#">场地预约</a></li>
            </ul>
            
           <el-button type="primary" @click="showAuditWindow(true,'通过')" v-show="filingCBtn">通过</el-button>
           <el-button type="primary" @click="showAuditWindow(false,'不通过')" v-show="backCBtn">不通过</el-button>
           <el-button type="primary" @click="applyChange(ruleForm.id)" v-show="ruleForm.historyid>=0">调度</el-button>
            <el-button @click.native="tabsCloseCurrentHandle">返回</el-button>
        </div>

    </div>
</template>
<script>
    import {tabsCloseCurrentHandle} from '@/utils/routeTab'
    import { mapState } from 'vuex'
    export default {
        data(){
            return {
                regionOption:'',
                placeOption:'',
                ruleForm: {
                    id: '',
                    processinstanceid: '',
                    historyid: -1,
                    secrecyStatus: '0',
                    businessType: 'GC',
                    applicantId: '',
                    applicant: '',
                    applyDateString: '',
                    applyTimeString: '',
                    applyTime: '',
                    applyTimeInterval: '',
                    businessId: '',
                    businessCode: '',
                    projectNo: '',
                    businessName: '',
                    remark: '',
                    platformCode: '',
                    comeFrom: 'WRITE',
                    details: [],
                    version:'1.0.0',
                    tradeOrgId:''
                },
                dialogVisible:false,
                reason:'',
                type:'',
                auditForm:{
                    isPass:null,
                    suggest:''
                },
                filingCBtn: false,
                backCBtn: false,

            }
        },
        activated() { 
            if (this.$route.query.id) {
            // this.gettradingCenterList();

            this.getDetailMessage();
            }
        },
        created(){
            this.$store.dispatch('region/getBusinessTypeList');
            this.$store.dispatch('region/getSecrecyStatusList');
            this.$store.dispatch('region/getApplyTimeIntervalList');
            this.$store.dispatch('region/getFieldBusClass');
            this.$store.dispatch('region/getApplyTypeList');
        },
        mounted(){
            if (this.$route.query.id) {
                this.getDetailMessage();
            }
        },
        computed:{
            ...mapState({
                businessTypeList: (state) => state.region.businessTypeList,
                secrecyStatusList: (state) => state.region.secrecyStatusList,
                applyTypeList: (state) => state.region.applyTypeList,
                applyTimeIntervalList: (state) => state.region.applyTimeIntervalList,
                fieldBusClass: (state) => state.region.fieldBusClass,
            })
        },
        methods:{
            getDetailMessage() {//单个查询
                this.$http.get('/field/applymanage/get?id=' + this.$route.query.id)
                    .then(res => {
                        console.log('预约修改detail', res.data.data);
                        this.$nextTick(() => {
                            this.ruleForm = res.data.data;
                            this.ruleForm.secrecyStatus=String(this.ruleForm.secrecyStatus)
                            this.$refs.flowChart.getFlow(this.ruleForm.processinstanceid)
                        })
                    })
            },
            tabsCloseCurrentHandle(){//返回列表页
                this.tabsCloseHandle('appointmentDetail');
                this.$router.push('/appointmentList')
            },
            convertApplyType(type) {//判断是什么类型场地
                var items = this.applyTypeList.filter(t => t.id == type);
                console.log(this.applyTypeList)
                if (items && items.length > 0) {
                    return items[0].text;
                }
                return "";
            },
            handleClose(){
              this.dialogVisible=false;
            },
            auditProcessSubmit(auditForm){//提交
                this.$set(this.ruleForm.variables,'commit' , auditForm.isPass);
                this.$set(this.ruleForm.variables,'opinion' ,auditForm.suggest);
                
                this.$http.post('/field/applymanage/processSubmit', this.ruleForm)
                .then(res => {
                    if (res.data.code == 1) {
                    this.$message.success(res.data.msg);
                    this.$refs.flowChart.getFlow(this.ruleForm.processinstanceid)
                    this.dialogVisible=false;
                    // this.tabsCloseCurrentHandle()
                    }else {
                    this.$message.error(res.data.msg);
                    }
                })
            },
            getFlowInfoSuccess(resData) {
                this.processSubmit = false;
                this.filingCBtn = false;
                this.backCBtn = false;
                if (resData.taskId !== '') {
                    resData.buttons.forEach(item => {
                        if (item.type == 1) {
                            this.processSubmit = true
                        }
                        if (item.type == 2) {
                            this.filingCBtn = true
                        }
                        if (item.type == 3) {
                            this.backCBtn = true
                        }
                    })
                    this.$set(this.ruleForm,'taskId' ,resData.taskId);
                }else{
                    
                }
            },
            showAuditWindow(isPass,msg){//打开审核弹框
                this.dialogVisible = true;
                this.auditForm.suggest = msg;
                this.auditForm.isPass = isPass;
            },
          applyChange(id){
              this.$confirm("是否发起场地变更？","提示").then((ok)=>{
                if (ok){
                  this.$http.get('/field/applymanagechg/change?id='+id)
                      .then(res => {
                        if (res.data.code == 1) {
                          this.$router.push({name:'siteChangeExit',query:{id:res.data.data.id}});
                        }else {
                          this.$message.error(res.data.msg);
                        }
                      })
                }
              })
          }

        }
    }
</script>
<style lang="scss" scoped>
    .detail{
        width: 1360px;
        display: flex;
        margin:18px auto;
        .left{
            width:1200px;
            .card-item {
                width: 100%;
                margin-top: 15px;
            }
            .demo-ruleForm{
                display: flex;
                flex-wrap:wrap;
                padding: 0;
                .el-form-item {
                    /deep/ .el-input-number--medium,/deep/ .el-date-editor ,/deep/ .el-input ,/deep/ .el-input--medium .el-input__inner {
                        width: 100%;
                    }
                }
                .el-form-item:nth-last-child(2){
                    width: 100%;
                }
            }
            /deep/ .el-radio {
                margin-right: 4px !important;
            }
        }
        .btns{
            width: 150px;
            height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            border: 1px solid #ebeef5;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            background-color: #fff;
            color: #303133;
            text-align: center;
            padding: 0 10px 10px 10px;
            position:fixed;
            right:150px;
            top:143px;
            .el-button--medium{
                width:100px;
                margin: 5px 0;
            }
            ul{
                width:100px;
                margin-bottom:5px;
                li{
                    a{
                        display: block;
                        padding: 10px 0;
                        text-align:center;
                        border-bottom: 1px solid #ddd;
                        position: relative;
                        color: #1f59a3;
                        cursor: pointer;
                    }
                }
            }
        }
        .examine{
            .btn{
                margin-top: 20px;
                text-align: right;
            }
            .el-textarea{
                width: 80%;
            }
        }
    }
@media screen and (max-width: 1680px) {
  .detail {
    .left {
      width: 1070px;
    }

    .btns {
      right: 80px;
    }
  }
}

@media screen and (max-width: 1600px) {
  .detail {
    .left {
      width: 950px;
    }
    .btns {
      right: 80px;
    }
  }
}

@media screen and (max-width: 1440px) {
  .detail {
    .left {
      width: 800px;
    }
    .btns {
      right: 110px;
    }
  }
}
</style>